import { render, staticRenderFns } from "./ProtectedUrlsList.vue?vue&type=template&id=00bafa1d&"
import script from "./ProtectedUrlsList.vue?vue&type=script&lang=js&"
export * from "./ProtectedUrlsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00bafa1d')) {
      api.createRecord('00bafa1d', component.options)
    } else {
      api.reload('00bafa1d', component.options)
    }
    module.hot.accept("./ProtectedUrlsList.vue?vue&type=template&id=00bafa1d&", function () {
      api.rerender('00bafa1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/ProtectedUrls/ProtectedUrlsList.vue"
export default component.exports